import { Link } from '../lib/router.tsx';

export function NotFound({ title = 'Nothing here', text = 'That page doesn’t exist (yet).' }: { title?: string; text?: string }) {
  return (
    <div className="page center">
      <img className="lost-king" src="/art/wK.svg" alt="" />
      <h1>{title}</h1>
      <p className="muted">{text}</p>
      <Link to="/" className="btn primary big">
        Play today’s variant
      </Link>
    </div>
  );
}

export function About() {
  return (
    <div className="page prose">
      <h1 className="page-title">About ChessBut</h1>
      <p>
        ChessBut is a new chess variant every day. Each one is regular chess with one twist: <i>chess, but snails hunt your king</i>,{' '}
        <i>chess, but…</i> whatever comes next. It started with a reel about a silly chess idea, and a developer who couldn’t stop building them.
      </p>
      <h2>How it works</h2>
      <ul>
        <li>Every day at midnight (New York time) a new variant drops and becomes today’s game.</li>
        <li>Play instantly, no account needed: online, against the computer, with a friend, or on one phone.</li>
        <li>Rated games use Glicko-2, the same scale as lichess. Every variant has its own rating, plus an overall one.</li>
        <li>The daily leaderboard resets every day. Today’s variant scores double.</li>
        <li>The daily challenge: everyone plays the same bot. Fewest moves to win takes the top spot.</li>
        <li>Every past variant stays playable in the archive.</li>
      </ul>
      <p>
        Made by <a href="https://techty.app">TechTy Studio</a>.
      </p>
    </div>
  );
}

export function Privacy() {
  return (
    <div className="page prose">
      <h1 className="page-title">Privacy</h1>
      <p>Short version: we keep what we need to run the game and count how it’s doing, and nothing goes to advertisers or trackers.</p>
      <h2>What we store</h2>
      <ul>
        <li>A random player id and session token, kept in your browser’s (or the app’s) local storage. There are no tracking cookies.</li>
        <li>
          If you create an account: your username, and the way you sign in: your email address (to send you sign-in codes), a salted hash of your
          password if you set one, or an id from Google or Apple if you use them. We only email you sign-in codes, never newsletters.
        </li>
        <li>Your games, ratings, points and streaks, which are shown on leaderboards and profiles if you have an account.</li>
        <li>
          Basic visit statistics: the day you visited, your country (from Cloudflare, not your exact location), your device type (phone, desktop,
          in-app browser) and which link brought you here. We use these to know how the game is doing.
        </li>
      </ul>
      <h2>What we don’t do</h2>
      <ul>
        <li>No third-party analytics or ad trackers, and we don’t sell data.</li>
        <li>We don’t store your IP address with your games.</li>
      </ul>
      <h2>Who else handles it</h2>
      <ul>
        <li>Cloudflare, which sits in front of the site.</li>
        <li>Resend, which delivers the sign-in emails (it sees the address and the email).</li>
      </ul>
      <h2>Deleting your data</h2>
      <p>
        Delete your account any time in Settings (signed in): your name, email, password, ratings and points are removed, and your past games stay in your
        opponents’ history as “Deleted player”. Guests can clear their browser’s site data. For anything else, contact details are on the TechTy Studio
        site.
      </p>
    </div>
  );
}
